import React, { Component, useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { deleteBanner, getBanners, saveBanner } from '../../actions/actionBanners';
import PageHeader from '../../components/Header/PageHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { ConfirmAction } from '../../components/Table/NewTable';
import Table from '../../components/Table/Table';
import BorderContainer from '../../components/SessionBorder/SessionBorder';
import { RenderToggleManaged } from '../../utils/formValidations';
import { Button, notifyFailure, notifySuccess, TabList } from '../../components/Form/Form';
import { faFloppyDisk } from '@fortawesome/pro-light-svg-icons/faFloppyDisk';
import { faBorderTop } from '@fortawesome/pro-light-svg-icons/faBorderTop';
import LoadingSpinner from '../../components/LoadingSpinner';


function BorderWizard (props) {
    const dispatch = useDispatch()
    const { t } = useTranslation('common');
    const { design, setDesign, existing } = props
    const details = existing?.config
    const [name, setName] = useState('');
    const [top, setTop] = useState(40);
    const [bottom, setBottom] = useState(0);
    const [left, setLeft] = useState(0);
    const [right, setRight] = useState(0);
    const [text, setText] = useState('Kasm Banner');
    const [textColor, setTextColor] = useState('#FFFFFF');
    const [bgColor, setBgColor] = useState('#21273F');
    const [fontSize, setFontSize] = useState(14);
    const [fontWeight, setFontWeight] = useState(600);
    const [allowClose, setAllowClose] = useState('false');
    const [allowEdit, setAllowEdit] = useState('false');
    const [currentTab, setCurrentTab] = useState("border");


    const [updatedDetails, setUpdatedDetails] = useState(details);

    useEffect(() => {
        if (existing) {
            setName(existing?.name)
            setTop(Number(details?.size.top))
            setBottom(Number(details?.size.bottom))
            setLeft(Number(details?.size.left))
            setRight(Number(details?.size.right))
            setText(details?.text)
            setTextColor(details?.font_color )
            setBgColor(details?.background_color )
            setFontSize(details?.font_size )
            setFontWeight(details?.font_weight )
            setAllowClose(details?.allow_close )
            setAllowEdit(details?.allow_edit )
        } else {
            resetWizard()
        }
        
    }, [existing, design]);



    useEffect(() => {
        setUpdatedDetails({
            background_color: bgColor, 
            font_color: textColor, 
            font_size: fontSize, 
            font_weight: fontWeight, 
            allow_close: allowClose, 
            allow_edit: allowEdit, 
            text, 
            size: { 
                top: Number(top), 
                left: Number(left), 
                right: Number(right), 
                bottom: Number(bottom) 
            } 
        })
    }, [top, bottom, left, right, text, textColor, bgColor, fontSize, fontWeight, allowClose, allowEdit]);

    const resetWizard = () => {
        setName('')
        setTop(40)
        setBottom(0)
        setLeft(0)
        setRight(0)
        setText('Kasm Banner')
        setTextColor('#FFFFFF')
        setBgColor('#21273F')
        setFontSize(14)
        setFontWeight(600)
        setAllowClose(false)
        setAllowEdit(false)
    }

    const saveDesign = async () => {
        try {
            let data = {
                config: JSON.stringify(updatedDetails),
                name: name
            }
            if (existing) {
                data['banner_id'] = existing.banner_id
            }

            const { response: { error_message: errorMessage } } = await dispatch(saveBanner(data));
            notifySuccess({ errorMessage, type: 'update' })
            setDesign(false)
            dispatch(getBanners())
        } catch (error) {
            notifyFailure({ error, type: 'update' })
        }
    }
    
    if (design) {
        const tabList = [
            { name: 'settings.border', key: 'border' },
            { name: 'settings.text', key: 'text' },
            { name: 'settings.additional', key: 'additional' },
        ]
        return (
        <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-bg-[image:var(--bg-trans)] tw-backdrop-blur-lg">
            
                <BorderContainer {...updatedDetails} showBorder={true} wizard={true} setDesign={setDesign}>
                    <div className="tw-absolute tw-w-24 tw-left-1/2 tw-h-full -tw-translate-x-1/2 tw-flex tw-items-center tw-flex-col tw-justify-between tw-py-5">
                        <div className="tw-w-24 tw-h-12 tw-flex tw-items-center tw-gap-2"><div className="input "><input type={"number"} value={top} onChange={(ev) => setTop(ev.target.value) } className="tw-w-20 tw-text-center" /></div>px</div>
                        <div className="tw-w-24 tw-h-12 tw-flex tw-items-center tw-gap-2"><div className="input "><input type={"number"} value={bottom} onChange={(ev) => setBottom(ev.target.value) } className="tw-w-20 tw-text-center" /></div>px</div>
                    </div>
                    <div className="tw-absolute tw-h-12 tw-top-1/2 -tw-translate-y-1/2 tw-flex tw-items-center tw-w-full tw-justify-between tw-px-2 sm:tw-px-5">
                        <div className="tw-w-24 tw-h-12 tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-2"><div className="input "><input type={"number"} value={left} onChange={(ev) => setLeft(ev.target.value) } className="tw-w-20 tw-text-center" /></div>px</div>
                        <div className="tw-w-24 tw-h-12 tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-gap-2"><div className="input "><input type={"number"} value={right} onChange={(ev) => setRight(ev.target.value) } className="tw-w-20 tw-text-center" /></div>px</div>
                    </div>
                    <div style={{ maxHeight: "calc(100% - " + (Number(top) + Number(bottom) + 150) + "px)"}} className="tw-overflow-auto tw-gap-5 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-w-3/5 tw-left-1/2 -tw-translate-x-1/2 tw-max-w-md tw-rounded-lg tw-p-8 tw-pt-4 tw-bg-[var(--modal-bg)] tw-border tw-border-solid tw-border-[var(--border-color)] tw-shadow-lg">
                        <TabList {...props} tabList={tabList} currentTab={currentTab} setCurrentTab={setCurrentTab} />
                        <div className={'tw-flex tw-flex-col tw-gap-3' + (currentTab === 'border' ? ' tw-block' : ' tw-hidden')}>
                            <div className="tw-flex tw-gap-2 sm:tw-items-center tw-flex-col sm:tw-flex-row"><div className="sm:tw-w-36">{ t('banner.name') }</div><div className="input !tw-w-40"><input type="text" value={name} onChange={(ev) => setName(ev.target.value) } className="" /></div></div>
                            <div className="tw-flex tw-gap-2 sm:tw-items-center tw-flex-col sm:tw-flex-row"><div className="sm:tw-w-36">{ t('settings.border-color') }</div><input type="color" value={bgColor} onChange={(ev) => setBgColor(ev.target.value) } className="" /></div>
                            <div className="tw-flex tw-gap-2 sm:tw-items-center tw-flex-col sm:tw-flex-row"><div className="sm:tw-w-36">{ t('settings.text-color') }</div><input type="color" value={textColor} onChange={(ev) => setTextColor(ev.target.value) } className="" /></div>
                            <div className="tw-flex tw-gap-2 sm:tw-items-center tw-flex-col sm:tw-flex-row"><div className="sm:tw-w-36">{ t('settings.font-size') }</div><div className="input !tw-w-40"><input type="number" value={fontSize} onChange={(ev) => setFontSize(ev.target.value) } className="" /></div><div>px</div></div>
                            <div className="tw-flex tw-gap-2 sm:tw-items-center tw-flex-col sm:tw-flex-row"><div className="sm:tw-w-36">{ t('settings.font-weight') }</div><div className="input !tw-w-40">
                                <select onChange={(e) => setFontWeight(e.target.value)} value={fontWeight} className="">
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                    <option value="600">600</option>
                                    <option value="700">700</option>
                                    <option value="800">800</option>
                                    <option value="900">900</option>
                                </select>
                            </div></div>

                        </div>
                        <div className={(currentTab === 'text' ? 'tw-block' : 'tw-hidden')}>
                        <div className="tw-flex tw-flex-col tw-gap-3">
                            <div className="input "><textarea onChange={(ev) => setText(ev.target.value) } className="tw-h-24" value={text}></textarea></div>
                            <div>{t('settings.available-vars')}</div>
                            <div className="tw-flex tw-flex-wrap tw-gap-2">
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {user_id}')}>{"{user_id}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {username}')}>{"{username}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {image_name}')}>{"{image_name}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {kasm_id}')}>{"{kasm_id}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {image_id}')}>{"{image_id}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {egress_provider_name}')}>{"{egress_provider_name}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {egress_gateway_name}')}>{"{egress_gateway_name}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {egress_gateway_country}')}>{"{egress_gateway_country}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {egress_gateway_city}')}>{"{egress_gateway_city}"}</code>
                            <code className="tw-cursor-pointer" onClick={() => setText(text + ' {zone_name}')}>{"{zone_name}"}</code>
                            </div>
                        </div>

                        </div>
                        <div className={(currentTab === 'additional' ? 'tw-block' : 'tw-hidden')}>
                            <div className="tw-flex tw-flex-col tw-gap-2">
                            <div className="tw-flex">
                                    <label className="tw-w-36" htmlFor="allow_close">{t('settings.allow_close')}</label>
                                    <RenderToggleManaged name="allow_close" id="allow_close" checked={!!allowClose} onChange={(ev) => setAllowClose(ev.target.checked)} />
                                </div>
                                <div className="tw-flex">
                                    <label className="tw-w-36" htmlFor="allow_edit">{t('settings.allow_edit')}</label>
                                    <RenderToggleManaged name="allow_edit" id="allow_edit" checked={!!allowEdit} onChange={(ev) => setAllowEdit(ev.target.checked)} />
                                </div>
                            </div>
                        </div>
                        <div className="tw-flex tw-mt-8 tw-gap-3">
                            <button className="tw-w-1/2 tw-bg-transparent" onClick={() => setDesign(false)}>Cancel</button>
                            <Button className="tw-w-1/2" icon={<FontAwesomeIcon icon={faFloppyDisk} />} type="button" section="buttons" name="Save" onClick={saveDesign} />
                        </div>
                    </div>
                </BorderContainer>
            
            
        </div>)
    }
}

export default function Banners(props) {
    const dispatch = useDispatch()
    const [deleteModal, setDeleteModal] = useState(false);
    const [design, setDesign] = useState(false);
    const [force, setForce] = useState(false);
    const [existing, setExisting] = useState(null);
    const [bannerId, setBannerId] = useState(null);
    const { t } = useTranslation('common');
    const banners = useSelector(state => state.banner.banners) || null
    const bannerLoading = useSelector(state => state.banner.bannerLoading) || false

    useEffect(() => {
        dispatch(getBanners())
    }, []);

    const deleteSingleBanner = async (id) => {
        try {
          const { response: { error_message: errorMessage } } = await dispatch(deleteBanner({ banner_id: id, force: !!force}));
          notifySuccess({ errorMessage, type: 'delete' })
        } catch (error) {
          notifyFailure({ error, type: 'delete' })
        }
        setDeleteModal(false)
      }
    

    const deleteBannerAction = async () => {
        // delete banner
        try {
            const { response: { error_message: errorMessage } } = await dispatch(deleteBanner({ banner_id: bannerId, force: !!force }))
            notifySuccess({ errorMessage, type: 'delete' })
        } catch (error) {
            notifyFailure({ error, type: 'delete' })
        }
        setDeleteModal(false)
        dispatch(getBanners())
    }

    const deleteConfirm = (bannerId) => {
        setDeleteModal(true)
        setBannerId(bannerId)
    }


    const tableColumns = [
        {
            type: "text",
            name: t("banner.name"),
            accessor: "name",
            filterable: true,
            sortable: true,
            colSize: 'minmax(200px, 1.2fr)'
        },
    ]

    const actions = [
        { id: "edit", icon: "fa-pencil", description: t("buttons.Edit") },
        { id: "delete", icon: "fa-trash", description: t("buttons.Delete") },
    ];

    const onAction = async (action, item) => {
        switch (action) {
            case "edit":
                setExisting(item)
                setDesign(true)
            break;

            case "delete":
                deleteConfirm(item.banner_id);
            break;
            case "deleteMulti":
                const promises = []
                item.forEach(id => {
                  const promise = deleteSingleBanner(id)
                  promises.push(promise)
                })
                await Promise.all(promises)
                dispatch(getBanners())

            break;

        }
    }


    
    if (bannerLoading){
        return (<div> <LoadingSpinner /></div>);
    }

    return (
        <div className="profile-page tw-relative">
        <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} help="kb-30-0" title={t('banner.banners')} icon={<FontAwesomeIcon icon={faBorderTop} />} />
        <div className="tw-w-10/12 tw-mx-auto">        
            <Table
                id="banner"
                data={banners}
                columns={tableColumns}
                actions={actions}
                onAction={onAction}
                mainId="banner_id"
                add={{
                    name: t('buttons.Add'),
                    onClick: () => { setExisting(null); setDesign(true) }
                }}
            />
        </div>
        <BorderWizard design={design} setDesign={setDesign} existing={existing} />
        <ConfirmAction
            confirmationDetails={{
                action: null,
                details: {
                    title: t('banner.delete-banner'),
                    text: t('branding.confirm_delete'),
                    iconBg: 'tw-bg-pink-700 tw-text-white',
                    icon: <FontAwesomeIcon icon={faTrash} />,
                    confirmBg: 'tw-bg-pink-700',
                    confirmText: t('buttons.Delete'),
                    additional: 
                    <div className="tw-text-center">
                        <label id="force_label" className="group-label tw-flex tw-justify-center tw-items-center tw-gap-3"><b className="tw-mb-2">{t('generic.force')}:</b> <RenderToggleManaged checked={!!force} name="force" onChange={setForce} /></label>
                        <div className="tw-text-xs">{t('banner.force_delete')}</div>
                    </div>
      

                }
            }}
            open={deleteModal}
            externalClose={true}
            setOpen={setDeleteModal}
            onAction={deleteBannerAction}
        />

    </div>)
}